import { render, staticRenderFns } from "./AreaReportDataTable.vue?vue&type=template&id=2cdb149c&"
import script from "./AreaReportDataTable.vue?vue&type=script&lang=js&"
export * from "./AreaReportDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports